// extracted by mini-css-extract-plugin
export var alignBaseline = "_l-9";
export var alignCenter = "_l-5";
export var alignFlexEnd = "_l-7";
export var alignFlexStart = "_l-6";
export var alignSelfBaseline = "_l-e";
export var alignSelfCenter = "_l-a";
export var alignSelfFlexEnd = "_l-c";
export var alignSelfFlexStart = "_l-b";
export var alignSelfStretch = "_l-d";
export var alignStretch = "_l-8";
export var column = "_l-2";
export var columnReverse = "_l-4";
export var flex = "_l-0";
export var justifyCenter = "_l-f";
export var justifyFlexEnd = "_l-h";
export var justifyFlexStart = "_l-g";
export var justifySpaceAround = "_l-j";
export var justifySpaceBetween = "_l-i";
export var justifySpaceEvenly = "_l-k";
export var row = "_l-1";
export var rowReverse = "_l-3";
export var wrapNowrap = "_l-m";
export var wrapWrap = "_l-l";
export var wrapWrapReverse = "_l-n";